import ApplicationSerializer from "./application";
import ENV from "glesys-controlpanel/config/environment";

export default class PrivateNetworkSerializer extends ApplicationSerializer {
  usesProxy = true;

  attrs = {
    project: "projectkey",
    status: { serialize: false },
  };

  normalize(modelClass, resourceHash, prop) {
    resourceHash.links = {
      segments: `${ENV.apiBaseUri}/privatenetwork/listsegments?privatenetworkid=${resourceHash.id}&includeadapters=1`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }
}
